// extracted by mini-css-extract-plugin
module.exports = {"icon-small":"index_icon-small_1wYKT","base-agreement-view":"index_base-agreement-view_3xvfo"};